<script>
export default {

    props: {
        handle: { type: String, required: true },
        value: { required: true },
        values: { required: true },
    }

}
</script>
